import { AfterContentInit, Component, Input } from '@angular/core';
import { chartConfig } from './portfolio-growth-chart.data';
import * as echarts from 'echarts';

@Component({
  selector: 'app-portfolio-growth-chart',
  imports: [],
  templateUrl: './portfolio-growth-chart.component.html',
})
export class PortfolioGrowthChartComponent implements AfterContentInit {
  @Input() dates: string[] = [];
  @Input() values: number[] = [];

  private chart!: any;
  private chartConfig!: any;

  ngAfterContentInit(): void {
    this.chartConfig = { ...chartConfig };
    this.chartConfig.xAxis[0].data = this.dates;
    this.chartConfig.series[0].data = this.values;

    this.setupChart();
  }

  private setupChart() {
    const chart = this.getChartInstance();
    const configOptions = { ...this.chartConfig };

    chart.setOption(configOptions);
    this.chart = chart;

    // Resize chart
    const container = document.getElementById('chart-area-container');
    if (container) {
      new ResizeObserver(() => chart.resize()).observe(container);
    }
  }

  private getChartInstance() {
    if (this.chart) {
      return this.chart;
    }

    return echarts.init(document.getElementById('chart-area'));
  }
}
